<template>
  <div class="field">
    <div class="is-flex">
      <label class="is-size-6 is-expanded">{{ label }}</label>
      <label class="is-size-7">{{ required ? 'required' : 'optional' }}</label>
    </div>
    <div class="control">
      <div
        class="select is-fullwidth"
        :class="{'is-danger': valid===false,'is-success':valid===true}"
      >
        <select v-model="model">
          <slot></slot>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "Label"
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    valid: {
      default: "unset"
    }
  },
  data() {
    return {
      model: ""
    };
  },
  watch: {
    value() {
      let component = this;
      component.model = component.value;
    },
    model() {
      let component = this;
      component.$emit("input", component.model);
    }
  }
};
</script>